import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import FilterBar from "./FilterBar";

const styles = () => ({
    title: {
        paddingRight: 10,
    },
})

const FilterBars = ({
    filterBars = [],
    onFilterSelected = () => null,
    filters,
}) =>
    <div className='flex flex-col justify-start items-start p-16'>
        { filterBars.map(filter => (
            <div key={filter.value} className='mb-16'>
                <FilterBar
                    title={filter.title}
                    options={filter.options}
                    selectedOption={filters[filter.value]}
                    onSelectOption={value => {
                        onFilterSelected(filter.value, value)
                    }}
                />
            </div>
        ))}
    </div>

FilterBars.propTypes = {
    filterBars: PropTypes.arrayOf(PropTypes.object),
    onFilterSelected: PropTypes.func,
    filters: PropTypes.object,
}

export default withStyles(styles)(FilterBars)



// WEBPACK FOOTER //
// ./src/components/FilterBars.js